import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _createProperty = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/items/custom-attributes`,
    payload,
    config
  )
}

const _getProperties = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items/custom-attributes?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/custom-attributes`


  return Request.get(
    url,
    config
  )
}

const _deleteProperty = propertyId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/items/custom-attributes/${propertyId}`, config)
}

const _updateProperty = (property) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/items/custom-attributes/${property._id}`, property, config)
}

const _getPropertyGroups = (params) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/items/custom-attribute-groups?${params.q}`, config)
}

const _createPropertyGroup = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/items/custom-attribute-groups`, payload, config)
}

const _deletePropertyGroup = propertyGroupId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/items/custom-attribute-groups/${propertyGroupId}`, config)
}

const _updatePropertyGroup = (propertyGroup) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/items/custom-attribute-groups/${propertyGroup._id}`, propertyGroup, config)
}

export default {
  updateProperty: _updateProperty,
  deleteProperty : _deleteProperty, 
  getProperties : _getProperties,
  createProperty : _createProperty,
  getPropertyGroups : _getPropertyGroups,
  createPropertyGroup : _createPropertyGroup,
  deletePropertyGroup : _deletePropertyGroup,
  updatePropertyGroup : _updatePropertyGroup
}
